import { useEffect, useState, type ReactNode } from "react";
import {
  HamburgerMenuContext,
  type HamburgerMenuContextType,
} from "./HamburgerMenuContext";
import { slide as Menu } from "react-burger-menu";

interface HamburgerMenuContextProviderProps {
  children: ReactNode;
}

export const HamburgerMenuContextProvider = ({
  children,
}: HamburgerMenuContextProviderProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [content, setContent] = useState<ReactNode | null>(null);

  const value: HamburgerMenuContextType = {
    openHamburgerMenu: (content: ReactNode) => {
      setIsOpen(true);
      setContent(content);
    },
    closeHamburgerMenu: () => {
      setIsOpen(false);
      setContent(null);
    },
    isHamburgerMenuOpen: isOpen,
  };

  useEffect(() => {
    const closeOnResize = () => {
      setIsOpen(false);
    };

    window.addEventListener("resize", closeOnResize);

    return () => {
      window.removeEventListener("resize", closeOnResize)
    }
  }, []);

  return (
    <HamburgerMenuContext.Provider value={value}>
      {children}
      <Menu
        right
        className="hamburger-menu"
        isOpen={isOpen}
        onStateChange={(state) => setIsOpen(state.isOpen)}
        burgerButtonClassName={!isOpen ? "bm-burger-button-hidden" : ""}
      >
        {content}
      </Menu>
    </HamburgerMenuContext.Provider>
  );
};
